import { useDecision } from '@optimizely/react-sdk';

import { OperationsName } from '../types/user';

import CanUser from './CanUser';

type CanUserWithFeatureFlagProps = {
  featureKey: string;
  enabledPermission: OperationsName;
  disabledPermission: OperationsName;
  children: JSX.Element;
};

function CanUserWithFeatureFlag({
  featureKey,
  enabledPermission,
  disabledPermission,
  children,
}: CanUserWithFeatureFlagProps) {
  const [decision] = useDecision(featureKey);
  const operation = decision.enabled ? enabledPermission : disabledPermission;

  return <CanUser operation={operation}>{children}</CanUser>;
}

export default CanUserWithFeatureFlag;
